import { isTruthy } from "@dashboard/library";

import {
  CallDetailsFragment,
  SentimentType,
  SentimentValue,
} from "@/graphql/generated/graphql";

export function mapToOverallSentiments(
  transcription: CallDetailsFragment["transcription"]
): Map<SentimentType, SentimentValue> | undefined {
  if (transcription?.__typename === "CallTranscription") {
    const overallSentiments = (
      transcription.insights?.sentiments?.overall ?? []
    ).filter(isTruthy);

    return overallSentiments.reduce((map, sentiment) => {
      if (!map.has(sentiment.type)) {
        map.set(sentiment.type, sentiment.value);
      }
      return map;
    }, new Map<SentimentType, SentimentValue>());
  }
}
